module.exports = __webpack_public_path__ + "img/slide1.dc1db9c7.svg";